import React, { useState, useEffect, useContext } from 'react';
import "./style.css"
import logo from "./sflogo.png";
import { Box, Grid, Tabs, Button, Typography, Divider, Tooltip, IconButton, Menu, MenuItem, FormControl, InputLabel, Select, Switch, FormGroup, FormControlLabel } from '@mui/material';
import profilePic from '../../../images/png/profilePicture.png';
import { Link } from 'react-router-dom';
import SFlogo from '../../SFImages/SFLogo.png';
import { FaCaretDown } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import { AppProperties, AppSetting } from '../../../common/functions';

import { useMediaQuery } from 'react-responsive';
import { HiDotsVertical } from "react-icons/hi";
import { PiCaretCircleDownLight } from "react-icons/pi";
import ApiRequestService from '../../../components/ApiRequestService';
import { AppContext } from '../../../AppContext';
import SFShortLogo from '../../../images/png/short_logo.png'


const SFNavbar = (props) => {

    const [loading, setLoading] = useState(false);
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);

    const appContext = useContext(AppContext);

    const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

    const params = new URLSearchParams(props.location.search);
    const quizName = decodeURIComponent(params.get("quiz_name"));

    const appSetting = AppSetting();
    const appProperties = AppProperties();

    const universitySuffix = appSetting && appSetting.REACT_APP_UNIVERSITY_SUFFIX
        ? (appSetting.REACT_APP_UNIVERSITY_SUFFIX.includes("lti") ? appSetting.REACT_APP_UNIVERSITY_SUFFIX.replace("_lti", "(carmen)") : appSetting.REACT_APP_UNIVERSITY_SUFFIX)
        : "";

    const pathName = window.location.pathname;

    const [helpSupportAnchorEl, setHelpSupportAnchorEl] = useState(null);
    const openHelpSupport = Boolean(helpSupportAnchorEl);
    const handleHelpAndSupportClick = (event) => {
        setHelpSupportAnchorEl(event.currentTarget);
    };

    const [profileAnchorEl, setProfileAnchorEl] = useState(null);
    const openProfile = Boolean(profileAnchorEl);
    const handleProfileClick = (event) => {
        setProfileAnchorEl(event.currentTarget);
    };

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const openMenu = Boolean(menuAnchorEl);
    const handleMenuClick = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const [isTakequizPage, setIsTakequizPage] = useState(pathName.includes("/takequiz"));

    useEffect(() => {
        setIsTakequizPage(pathName.includes("/takequiz"));
    }, [props])

    useEffect(() => {
        if (appContext && appContext.studentEnrolledCourses) {
            setCourses(appContext.studentEnrolledCourses);
        }

        if (appContext && appContext.selectedCourse) {
            setSelectedCourse(appContext.selectedCourse);
        }
    }, [appContext])

    const handleClose = () => {
        setHelpSupportAnchorEl(null);
        setProfileAnchorEl(null);
        setMenuAnchorEl(null);
    };


    const logout = () => {
        if (appProperties.enableLogin) {
            window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'token', '');
            window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'GivenName', '');
            window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'USER_NAME', '');
            window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'UnixEpoch', '');
            window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'emailid', '');
            window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'OSUID', '');
            window.localStorage.setItem(appSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'role', '');
            window.localStorage.setItem('isLTIStudent', '');
            window.localStorage.setItem('practiceCourseID', '');
            window.localStorage.setItem('anonymous_assignment_url', '');
            window.location.reload();
        }
    };

    const handleCourseSelect = (event) => {
        let courseID = event.target.value;
        let selectedCourse = courses.find(course => course.course_id === courseID)
        setSelectedCourse(selectedCourse)
        console.debug("appContext>>>", appContext);
        if (appContext && appContext.updateSelectedCourse) {
            appContext.updateSelectedCourse(selectedCourse)
        }

    }

    const getPerformanceAnalytics = (selectedCourse, pathName) => {

        let name = "Practice & Analytics";
        if (selectedCourse) {
            switch (selectedCourse.enable_practice_and_performance) {
                case 1:
                    name = "Practice"
                    break;
                case 2:
                    name = "Practice & Analytics"
                    break;
                default:
                    break;
            }

        }

        if (appProperties.enableLTI === null || appProperties.enableLTI === undefined || appProperties.enableLTI === false) {
            return (
                <Link to="/performanceAnalytics" className='sf-nav-link'>
                    <Button className={pathName === '/performanceAnalytics' ? 'sf-nav-selected' : 'sf-nav-btn'}>{name}</Button>
                </Link>
            )
        }

        if (window.localStorage.getItem("practiceCourseID") || params.get("courseID")) {
            return (
                <Link to="/performanceAnalytics" className='sf-nav-link'>
                    <Button className={pathName === '/performanceAnalytics' ? 'sf-nav-selected' : 'sf-nav-btn'}>{name}</Button>
                </Link>
            )
        }
    }


    return (
        <div className='sf-navbar' style={{
            display: isTakequizPage ? 'none' : 'block'
        }}>
            <Grid container style={{ height: '100%', position: 'relative' }}>
                <Grid item xs={6}>
                    {isTakequizPage ?
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', height: '100%' }}>
                            <div className='ml-5'>
                                <div className='fontClass-20 font-weight-bold'>
                                    <span style={{ color: '#BA0C2F' }}>Assignment</span>
                                    <span> - {quizName} </span>
                                </div>
                                <div>PHY 111 Autumn 2022 General Physics, Meltzer</div>
                            </div>

                        </div>
                        :
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', height: '100%' }}>
                            <Link to="/" className='sf-nav-link'>
                                <img className='Sf-logo-full' src={SFlogo} alt="Stemfluency Logo" height='60' />
                                <img className='Sf-logo-short' src={SFShortLogo} alt="Stemfluency Short Logo" height='50' />
                            </Link>
                            {appProperties && appProperties.currentUserData && appProperties.currentUserData.role !== "0" ?
                                <div className='flex-column justify-content-center h-100 student-mode-toggle'>
                                    <FormGroup>
                                        <FormControlLabel
                                            onChange={(e) => {
                                                if (appContext.updateStudentMode) {
                                                    appContext.updateStudentMode(e.target.checked);
                                                }
                                            }}
                                            checked={appContext?.studentMode}
                                            control={<Switch defaultChecked />}
                                            className='m-0'
                                            label="Student Mode"
                                        />
                                    </FormGroup>
                                </div>
                                : null}
                        </div>
                    }

                </Grid>

                {!isMobile ?

                    <Grid className='sf-app-nav-items align-items-center' item xs={6} style={{ height: '100%' }} display={'flex'} gap={2} justifyContent={'flex-end'}>
                        {appProperties.enableLTI || (!appContext?.studentMode && appProperties.currentUserData && appProperties.currentUserData.role !== "0") ? null :
                            <FormControl className="sf-nav-formControl" variant="standard" sx={{ m: 1, minWidth: 250 }}>
                                <InputLabel id="demo-simple-select-standard-label">All Courses</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    onChange={handleCourseSelect}
                                    value={selectedCourse ? selectedCourse.course_id : -1}
                                    label="All Courses"
                                >
                                    {courses?.map(course => {
                                        return <MenuItem key={course.course_id} value={course.course_id}>{course.course_name}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        }
                        {/* {appProperties.enableLTI ? null : */}
                        <Link to="/" className='sf-nav-link'>
                            <Button
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "#FFF"
                                    }
                                }}
                                className={pathName === '/' ? 'sf-nav-selected' : 'sf-nav-btn'}>Home</Button>
                        </Link>
                        {/* } */}
                        {/* {selectedCourse && selectedCourse.enable_practice_and_performance !== 0 ? */}
                        {/* {appProperties && appProperties.currentUserData && appProperties.currentUserData.role !== "0" ?
                            getPerformanceAnalytics(selectedCourse, pathName)
                            : null} */}
                        {/* : null} */}
                        <Button
                            id="help-and-support"
                            aria-controls={openHelpSupport ? 'help-and-support-menu' : undefined}
                            aria-haspopup="true"
                            sx={{
                                "&:hover": {
                                    backgroundColor: "#FFF"
                                }
                            }}
                            aria-expanded={openHelpSupport ? 'true' : undefined}
                            onClick={handleHelpAndSupportClick}
                            className={["/about", "/troubleShooting", "/FAQ"].includes(pathName) ? 'sf-nav-selected' : 'sf-nav-btn'}
                        >
                            Help & Support

                            <FaCaretDown color='#BA0C2F' />
                        </Button>
                        <Menu
                            className='sf-nav-menu'
                            disableScrollLock={true}
                            id="help-and-support-menu"
                            anchorEl={helpSupportAnchorEl}
                            open={openHelpSupport}
                            onClose={handleClose}
                            slotProps={{
                                paper: {
                                    style: {
                                        width: 232
                                    }
                                }
                            }}
                            MenuListProps={{
                                'aria-labelledby': 'help-and-support',
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >

                            <Link to="/about" className='sf-nav-link'>
                                <MenuItem className='sf-nav-menu-item' onClick={handleClose} >About</MenuItem>
                            </Link>
                            <Link to="/troubleShooting" className='sf-nav-link'>
                                <MenuItem className='sf-nav-menu-item' onClick={handleClose} >Techincal Trouble Shooting</MenuItem>
                            </Link>
                            <Link to="/FAQ" className='sf-nav-link'>
                                <MenuItem className='sf-nav-menu-item' onClick={handleClose} >FAQ</MenuItem>
                            </Link>
                        </Menu>

                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', height: '100%' }}>
                            {/* <div className='sf-navbar-profile'
                                id="profile"
                                aria-controls={openProfile ? 'profile-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openProfile ? 'true' : undefined}
                                onClick={handleProfileClick}>
                                <div
                                    style={{
                                        width: '100%',
                                    }}
                                    className='d-flex justify-content-center flex-column align-items-center'
                                >
                                    <div style={{ width: "100px", textAlign: 'center', position: 'relative' }}>
                                        <Typography noWrap align='center' fullWidth paddingRight={1} fontSize={16} color={'white'} fontWeight={'500'}>
                                            {appProperties?.currentUserData?.USER_NAME}
                                        </Typography>
                                    </div>
                                    <Typography align='center' fullWidth paddingRight={1} fontSize={12} color={'white'} >
                                        Student, {universitySuffix.toUpperCase()}
                                    </Typography>
                                </div>
                                <div>
                                    <FaUserCircle fontSize={40} color='#fff' />
                                </div>
                            </div> */}
                            <div className='sf-new-navbar-profile d-flex justify-content-start align-items-center cursor-pointer' style={{
                                minWidth: '170px',
                            }}
                                id="profile"
                                aria-controls={openProfile ? 'profile-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={openProfile ? 'true' : undefined}
                                onClick={handleProfileClick}
                            >
                                <div>
                                    <FaUserCircle color='#646A6E' fontSize={40} />
                                </div>
                                <div className='px-2'>
                                    <Tooltip title={appProperties?.currentUserData?.USER_NAME}
                                        disableHoverListener={appProperties?.currentUserData?.USER_NAME && appProperties?.currentUserData?.USER_NAME.length > 12 ? false : true}
                                    >
                                        <div style={{ width: '100px' }}>
                                            <Typography noWrap fontWeight={700}>
                                                {appProperties?.currentUserData?.USER_NAME}
                                            </Typography>
                                        </div>
                                    </Tooltip>
                                    <Typography fontSize={12} color="#646A6E" fontWeight={500}>
                                        Student, {universitySuffix.toUpperCase()}
                                    </Typography>
                                </div>
                                <div>
                                    <PiCaretCircleDownLight fontSize={26} fontWeight={300} />
                                </div>
                            </div>

                            <Menu
                                className='sf-nav-menu'
                                disableScrollLock={true}
                                id="profile-menu"
                                anchorEl={profileAnchorEl}
                                open={openProfile}
                                onClose={handleClose}
                                slotProps={{
                                    paper: {
                                        style: {
                                            width: 160,
                                        }
                                    }
                                }}
                                MenuListProps={{
                                    'aria-labelledby': 'profile',
                                }}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                <Link to="/profile" className='sf-nav-link'>
                                    <MenuItem className='sf-nav-menu-item' onClick={handleClose} >Manage Profile</MenuItem>
                                </Link>
                                <Link to="/settings" className='sf-nav-link'>
                                    <MenuItem className='sf-nav-menu-item' onClick={handleClose} >Settings</MenuItem>
                                </Link>
                                <MenuItem className='sf-nav-menu-item' style={{
                                    color: '#BA0C2F'
                                }} onClick={logout} >Logout</MenuItem>
                            </Menu>
                        </div>
                    </Grid>


                    :

                    <Grid item xs={6} display={'flex'} justifyContent={'flex-end'}>
                        {appProperties.enableLTI ? null :
                            <FormControl className="sf-nav-formControl" variant="standard" sx={{ m: 1, minWidth: 250 }}>
                                <InputLabel id="demo-simple-select-standard-label-mobile">All Courses</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label-mobile"
                                    id="demo-simple-select-standard-mobile"
                                    onChange={handleCourseSelect}
                                    value={selectedCourse ? selectedCourse.course_id : -1}
                                    label="All Courses"
                                >
                                    {courses?.map(course => {
                                        return <MenuItem key={course.course_id} value={course.course_id}>{course.course_name}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        }
                        <IconButton
                            onClick={handleMenuClick}
                            aria-controls={openMenu ? 'takequiz-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openMenu ? 'true' : undefined}
                        >
                            <HiDotsVertical color='#bb0000' fontSize={32} />
                        </IconButton>
                        <Menu
                            className='sf-takequiz-menu'
                            disableScrollLock={true}
                            onClick={handleClose}
                            id="takequiz-menu"
                            anchorEl={menuAnchorEl}
                            open={openMenu}
                            onClose={handleClose}
                            slotProps={{
                                paper: {
                                    style: {
                                        width: 220,
                                    }
                                }
                            }}
                            MenuListProps={{
                                'aria-labelledby': 'menu',
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            {appProperties && appProperties.currentUserData && appProperties.currentUserData.role !== "0" ?
                                <div className='d-flex flex-column justify-content-center h-100'>
                                    <FormGroup>
                                        <FormControlLabel
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                if (appContext.updateStudentMode) {
                                                    appContext.updateStudentMode(e.target.checked);
                                                }
                                            }}
                                            checked={appContext?.studentMode}
                                            control={<Switch defaultChecked />}
                                            className='m-0'
                                            label="Student Mode"
                                        />
                                    </FormGroup>
                                </div>
                                : null}
                            {appProperties.enableLTI ? null :
                                <MenuItem className='sf-nav-menu-item'>
                                    <Link to="/" className='sf-nav-link w-100'>
                                        Home
                                    </Link>
                                </MenuItem>
                            }
                            <MenuItem className='sf-nav-menu-item'>
                                {appProperties && appProperties.currentUserData && appProperties.currentUserData.role !== "0" ?
                                    getPerformanceAnalytics(selectedCourse, pathName)
                                    : null}
                            </MenuItem>
                            <MenuItem className='sf-nav-menu-item'>
                                <Link to="/settings" className='sf-nav-link w-100'>
                                    Settings
                                </Link>
                            </MenuItem>
                            <MenuItem className='sf-nav-menu-item'>
                                <Link to="/profile" className='sf-nav-link w-100'>
                                    Profile
                                </Link>
                            </MenuItem>
                            <MenuItem className='sf-nav-menu-item'>
                                <Link to="/about" className='sf-nav-link w-100'>
                                    About
                                </Link>
                            </MenuItem>
                            <MenuItem className='sf-nav-menu-item'>
                                <Link to="/troubleShooting" className='sf-nav-link w-100'>
                                    Troubleshooting
                                </Link>
                            </MenuItem>
                            <MenuItem className='sf-nav-menu-item'>
                                <Link to="/FAQ" className='sf-nav-link w-100'>
                                    FAQ
                                </Link>
                            </MenuItem>

                            <MenuItem className='sf-nav-menu-item' onClick={logout} >Logout</MenuItem>
                        </Menu>
                    </Grid>
                }

            </Grid>
        </div >
    );
}

export default SFNavbar;
